import type { AppSettings } from '../types';
import type { DataPort } from './contract';
import { BrowserSqliteData } from './sqlite';

export function createDataPort(settings?: AppSettings): DataPort {
  return new BrowserSqliteData(settings?.userKey || 'default');
}
